<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <input :id="id" ref="input" v-bind="{ ...$attrs, class: null }" class="form-input" :class="{ error: error }" :type="type" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
    <div v-if="zillow" class="absolute float-right right-5 top-9 mr-5">
      <a :href="zillow" class="text-sm" target="_blank">
        <div class="float-right"><i class="ml-2 text-lg fas fa-location-arrow text-blue-500" /></div>
        <div class="hidden md:block float-right">View Property</div>
      </a>
    </div>
    <div v-if="type ==='link' && modelValue" class="absolute float-right right-5 top-9 mr-5">
      <a :href="modelValue" class="text-sm" target="_blank">
        <div class="float-right"><i class="ml-2 text-lg fas fa-link text-blue-500" /></div>
      </a>
    </div>
    <div v-if="ipLink" class="absolute float-right right-5 top-9 mr-5">
      <a :href="ipLink" class="text-sm" target="_blank">
        <div class="float-right"><i class="ml-2 text-lg fas fa-link text-blue-500" /></div>
        <div class="hidden md:block float-right">View Location</div>
      </a>
    </div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: String,
    zillow: String,
    ipLink: String,
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
